import { render } from "./PageVoteConfirmation.vue?vue&type=template&id=976f5a3a"
import script from "./PageVoteConfirmation.vue?vue&type=script&lang=js"
export * from "./PageVoteConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__